import React, { useContext, useEffect, useState } from "react";
import { accountsURL, teacherURL } from "../Hooks/URL";
import useFetch from "../Hooks/useFetch";
import useDelete from "../Hooks/useDelete";
import { useParams } from "react-router-dom";
import { userContext } from "../Contexts/userContext";
import useSave from "../Hooks/useSave";
import AccountsDetails from "../Templates/Home/Accounts/AccountsDetails/AccountsDetails";

function AccountDetailsPage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id } = useParams();

  const url = `${accountsURL}/${id}`;

  const [account, setAccount] = useState({});
  const { data, loading, error } = useFetch(url);

  const [go, setGo] = useState(false);
  const { deleteRes } = useDelete(url, go, `accounts`);

  useEffect(() => {
    if (!loading && !error && data) {
      setAccount(data.data);
    }
  }, [data, loading, error]);

  return (
    <AccountsDetails
      url={url}
      loading={loading}
      role={contextData?.role}
      account={account}
      setGo={setGo}
    />
  );
}

export default AccountDetailsPage;
